/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/MvvmStructure/Service/BakedInSolvablesService',[
    'lodash',
    'jszip',
    'jsziputils'
],
    function (_, JSZip, JSZipUtils) {
        "use strict";

        var BakedInSeeds = {

            _solvable: [],
            
            Initialize: function (onSuccess, onError) {
                this.GetBakedInSolvables(onSuccess, onError);
            },

            LoadBakedInSolvablesFromCDN: function (onSuccess, onError) {

                var url = "https://cdn.zone.msn.com/assets/games/microsoftsolitairecollection/2020/content/solvables001.zip";

                JSZipUtils.getBinaryContent(url, function (err, data) {
                    if (err) {
                        onError(err);
                        return;
                    }

                    try {

                        JSZip.loadAsync(data).then(function (zip) {
                            Object.keys(zip.files).forEach(function (filename) {                                                                                                                               
                                zip.files[filename].async('string').then(function (fileData) {
                                    if (fileData) {
                                        var path = this.split('/');

                                        if (path[path.length - 1].includes('.csv')) {

                                            var game = {
                                                name: path[(path.length - 2)],
                                                difficulty: path[path.length - 1].split('.')[0],
                                                seeds: fileData.split('\n')
                                            };
                                            onSuccess(game);
                                        }
                                    }
                                    
                                }.bind(filename));

                            }.bind(this));
                        }.bind(this));

                    } catch (e) {
                        onError(e);
                    }

                }.bind(this));
            },

            GetBakedInSolvables: function (onSuccess, onError) {

                this.LoadBakedInSolvablesFromCDN(
                    function (response) {
                        this._solvable.push(response);
                        onSuccess(response);
                    }.bind(this),
                    function (message) {
                        this._isValid = false;
                        onError(message)
                    }.bind(this));
            },

            GetSolvables: function () {
                return this._solvable;
            }
        };

        return BakedInSeeds;
    });
